import React from 'react'
import SubmitButton from '../../Form/SubmitButton/index'

const LinkButtonWithTextUnstyled = ({ label, ...otherProps }) => (
  <a {...otherProps}>
    <SubmitButton>{label}</SubmitButton>
  </a>
)

export default LinkButtonWithTextUnstyled



// WEBPACK FOOTER //
// ./src/Components/Buttons/LinkButtonWithText/unstyled.js